import TagManager from "react-gtm-module";
const env = process.env.NODE_ENV || "development";

const GA_TRACKING_ID = env === "development" ? "" : "AW-668662670";
const devMode = env === "development";
const pageView = (url) => {
  !devMode &&
    window.gtag("event", "page_view", {
      page_path: url,
      send_to: GA_TRACKING_ID,
    });
};

const completeRegistrationEvent = () => {
  !devMode &&
    window.gtag("event", "conversion", {
      send_to: `${GA_TRACKING_ID}/HrsbCN3D_9YBEI73674C`,
    });
};

const conversionInitPageEvent = () => {
  !devMode &&
    window.gtag("event", "conversion", {
      send_to: `${GA_TRACKING_ID}/JBjtCJ7A_9YBEI73674C`,
    });
};

const send = (dataLayer) => {
  console.log("sending:", devMode);
  //send data to tag manager only on web and not in webview mode
  if (!window.location.href.includes("stage/mobile")) {
    !devMode && TagManager.dataLayer(dataLayer);
  }
};

export const GetDataLayer = (name, field, data) => {
  return {
    dataLayer: {
      event: name,
      [field]: data,
    },
  };
};

export default {
  pageView,
  completeRegistrationEvent,
  conversionInitPageEvent,
  send,
  GetDataLayer,
};
